import ConfirmedPassword from './ConfirmedPassword'

export default ConfirmedPassword
